module.exports = __webpack_public_path__ + "img/headPic.0fa4df1c.jpg";